import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { GenericListApiResponse, GenericItemApiResponse, ApiResponse } from 'src/app/core/_interface/apiResponse';
import { Group } from 'src/app/core/_interface/product';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  groupSaved = new Subject<Group>();
  groupDeleted = new Subject<number>();

  constructor(private http: HttpClient) {

  }

  translate(companyID: number, from: any, to: any) {
    const url = environment.apiBase + `group/translate?companyID=${companyID}&from=${from}&to=${to}`;
    return this.http.post<ApiResponse>(url, null)
      .pipe(
        map(response => {
          if (response.success) {
            return true;
          }
          throw response;
        })
      );
  }

  get(companyID: number): Observable<Group[] | undefined> {
    const url = environment.apiBase + `group/get?companyID=${companyID}`;
    return this.http.get<GenericListApiResponse<Group>>(url)
      .pipe(
        map(response => {
          if (response.success) {
            return response.items;
          }
          return undefined;
        })
      );
  }

  delete(companyID: number, groupID: number) {
    const url = environment.apiBase + `group/delete?companyID=${companyID}`;
    return this.http.post<ApiResponse>(url, groupID)
      .pipe(
        map(response => {
          return response.success;
        }),
        tap(p => {
          if (p) this.groupDeleted.next(groupID);
        })

      );
  }

  save(product: Group): Observable<Group | undefined> {
    const url = environment.apiBase + `group/save`;
    return this.http.post<GenericItemApiResponse<Group>>(url, product)
      .pipe(
        map(response => {
          if (response.success) {
            return response.item;
          }
          return undefined;
        }),
        tap(g => {
          if (g) {
            this.groupSaved.next(g)
          }
        })
      );
  }

  saveGroupOrder(companyID: number, order: number[]): Observable<boolean> {
    const url = environment.apiBase + `group/saveOrder?companyID=${companyID}`;
    return this.http.post<ApiResponse>(url, order)
      .pipe(
        map(response => {
          return response.success;
        })
      );
  }


  saveGroupSortOrders(companyID: number, userOrder: number[], waiterOrder: number[]): Observable<boolean> {
    const url = environment.apiBase + `group/SaveSortOrders`;

    var data = {
      companyID,
      userOrder,
      waiterOrder
    };

    return this.http.post<ApiResponse>(url, data)
      .pipe(
        map(response => {
          if (!response.success) {
            throw response;
          }
          return response.success;
        })
      );
  }


  saveProductOrder(companyID: number, groupID: number, order: number[]): Observable<boolean> {
    const url = environment.apiBase + `group/SaveProductOrder?companyID=${companyID}&groupID=${groupID}`;
    return this.http.post<ApiResponse>(url, order)
      .pipe(
        map(response => {
          return response.success;
        })
      );
  }


  setIsAvailable(companyID: number, groupID: number, isAvailable: boolean) {
    const url = environment.apiBase + `group/SetIsAvailable`;

    var data = {
      companyID,
      groupID,
      isAvailable
    };


    return this.http.post<ApiResponse>(url, data)
      .pipe(
        map(response => {
          if (!response.success) {
            throw response;
          }
          return response.success;
        })
      );
  }


  uploadImage(groupID: number, file: File): Observable<string> {
    const url = environment.apiBase + 'group/uploadImage?groupID=' + groupID;

    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);

    return this.http.post<GenericItemApiResponse<string>>(url, formData)
      .pipe(
        map(response => {
          if (response.success) {
            return response.item;
          }
          throw response;
        })
      );
  }

  deleteImage(groupID: number) {
    const url = environment.apiBase + 'group/DeleteImage?groupID=' + groupID;

    return this.http.post<ApiResponse>(url, null)
      .pipe(
        map(response => {
          return response.success;
        })
      );
  }

}
